import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import ServicePage from "../ServicePage/ServicePage";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import TermsPage from "../TermsPage/TermsPage";
import PrivacyPage from "../PrivacyPage/PrivacyPage";
import ContactPage from "../ContactPage/ContactPage";
import HelpUs from "../HelpPage/HelpUs";
import KycUploadPage from "../HelpUsPages/KycUploadPage";
import LivenessCheck from "../HelpUsPages/LivenessCheck";
import FinishCheck from "../HelpUsPages/FinishCheck";
import OnboardingFAQ from "../HelpUsPages/OnboardingFAQ";
import DataSafty from "../HelpUsPages/DataSafty";
import GeneralFaq from "../HelpUsPages/GeneralFaq";
import IndiaHomePage from "../HomePage/IndiaHomePage";
import PakistanHomePage from "../HomePage/PakistanHomePage";
import BangladeshHomePage from "../HomePage/BangladeshHomePage";
import NepalHomePage from "../HomePage/NepalHomePage";
import SrilankaHomePage from "../HomePage/SrilankaHomePage";
import MalyasiaHomePage from "../HomePage/MalyasiaHomePage";
import PhilipphinsHomePage from "../HomePage/PhilipphinsHomePage";
import NigeriaHomePage from "../HomePage/NigeriaHomePage";
import ComplaintPage from "../ComplaintePage/ComplaintPage";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="help" element={<HelpUs />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="aboutus" element={<AboutUsPage />} />
          <Route path="service-single/:slug" element={<HelpUs />} />
          <Route path="kycupload" element={<KycUploadPage />} />
          <Route path="finishcheck" element={<FinishCheck />} />
          <Route path="livenesscheck" element={<LivenessCheck />} />
          <Route path="onboardingFAQ" element={<OnboardingFAQ />} />
          <Route path="datasafty" element={<DataSafty />} />
          <Route path="generalFaq" element={<GeneralFaq />} />
          <Route path="send-money-to-india" element={<IndiaHomePage />} />
          <Route path="send-money-to-pakistan" element={<PakistanHomePage />} />
          <Route path="send-money-to-bangladesh" element={<BangladeshHomePage />} />
          <Route path="send-money-to-nepal" element={<NepalHomePage />} />
          <Route path="send-money-to-sri-lanka" element={<SrilankaHomePage />} />
          {/* <Route path="send-money-to-sri%20lanka" element={<SrilankaHomePage />} /> */}
          <Route path="send-money-to-malaysia" element={<MalyasiaHomePage />} />
          <Route path="send-money-to-philipphins" element={<PhilipphinsHomePage />} />
          <Route path="send-money-to-philippines" element={<PhilipphinsHomePage />} />
          <Route path="send-money-to-nigeria" element={<NigeriaHomePage />} />
          <Route path="terms-conditions" element={<TermsPage />} />
          <Route path="privacy-policy" element={<PrivacyPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="file-a-complaint" element={<ComplaintPage />} />



        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
